import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/Avatar/components/Container.js';
import { ProfileButton } from '../../primitives/Avatar/components/ProfileButton.js';
import { IconButton } from '../../primitives/IconButton/index.js';
import { HEADER_QA_ID, qaId } from '../../utils/qaId.js';
export const Avatar = /*#__PURE__*/_styled(forwardRef(({
  initials = '',
  size = 'small',
  ...restProps
}, ref) => {
  return _jsx(Container, {
    tabIndex: 0,
    ref: ref,
    "data-testid": qaId(HEADER_QA_ID, 'headercontrol', 'avatar'),
    size: size,
    children: _jsx(IconButton, {
      ...restProps,
      category: "secondary",
      children: _jsx(ProfileButton, {
        size: size,
        children: initials
      })
    })
  });
}), process.env.NODE_ENV === "production" ? {
  target: "eixtugl0"
} : {
  target: "eixtugl0",
  label: "Avatar"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkF2YXRhci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTSSIsImZpbGUiOiJBdmF0YXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQXZhdGFyL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IFByb2ZpbGVCdXR0b24gfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0F2YXRhci9jb21wb25lbnRzL1Byb2ZpbGVCdXR0b24uanMnO1xuaW1wb3J0IHsgSWNvbkJ1dHRvbiB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvSWNvbkJ1dHRvbi9pbmRleC5qcyc7XG5pbXBvcnQgeyBIRUFERVJfUUFfSUQsIHFhSWQgfSBmcm9tICcuLi8uLi91dGlscy9xYUlkLmpzJztcbmV4cG9ydCBjb25zdCBBdmF0YXIgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBpbml0aWFscyA9ICcnLCBzaXplID0gJ3NtYWxsJywgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4ge1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgdGFiSW5kZXg6IDAsIHJlZjogcmVmLCBcImRhdGEtdGVzdGlkXCI6IHFhSWQoSEVBREVSX1FBX0lELCAnaGVhZGVyY29udHJvbCcsICdhdmF0YXInKSwgc2l6ZTogc2l6ZSwgY2hpbGRyZW46IF9qc3goSWNvbkJ1dHRvbiwgeyAuLi5yZXN0UHJvcHMsIGNhdGVnb3J5OiBcInNlY29uZGFyeVwiLCBjaGlsZHJlbjogX2pzeChQcm9maWxlQnV0dG9uLCB7IHNpemU6IHNpemUsIGNoaWxkcmVuOiBpbml0aWFscyB9KSB9KSB9KSk7XG59KSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1BdmF0YXIuanMubWFwIl19 */");